import React, { useState, useEffect } from "react";
import axios from "axios";
import DashboardNavigation from "./../../DashboardNavigation/DashboardNavigation";
import useScrollToTop from "./../../../hooks/useScollToTop";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import { useUser } from "../../Home/UserContext";
import { getRoleFromRoleId } from "../../../utils/roleHelper";
import { format } from "date-fns";

const RequestsAdmin = () => {
  useScrollToTop();
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  const [updatesData, setUpdatesData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fonction pour récupérer les requêtes depuis l'API externe
  const fetchUpdate = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.monappliclub.com/api/updates/AllUpdates`
      );
      if (Array.isArray(response.data)) {
        setUpdatesData(response.data);
      } else {
        throw new Error("Les données reçues ne sont pas un tableau.");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des requêtes :", error);
      toast.error("Erreur lors de la récupération des requêtes");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUpdate();
  }, []);

  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px] dark:text-white">
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.4em] text-gray-800 text-center dark:text-white mb-4">
        ADMINISTRATEUR
      </h2>
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-widest text-gray-800 text-center dark:text-white mb-4 font-montserrat uppercase">
        Mise à jour de l'application
      </h2>
      <DashboardNavigation role={userRole} />
      <div className="text-center p-4 bg-blue-100 rounded-lg shadow max-w-[800px] mx-auto mb-4 dark:text-gray-800">
        <p className="text-lg font-semibold mb-2">
          Bienvenue sur la page des Mises à jour de l'application
        </p>
        <p className="text-sm text-left">Sur cette page, seront affichées :</p>
        <p className="text-sm text-left">
          🔹Des corrections de bugs
          <br />
          🔹les mises à jour
          <br />
          🔹les nouvelles fonctionnalités de l'application
          <br />
        </p>
      </div>
      <div className="flex flex-col items-center w-full px-4 mt-4">
        {loading ? (
          <p>Chargement des données...</p>
        ) : (
          <>
            <div className="bg-gray-100 dark:bg-gray-500 shadow-lg max-w-full mx-auto font-montserrat pb-10">
              <div className="overflow-x-auto">
                <table className="table-auto bg-white dark:bg-slate-300 font-montserrat w-full mx-auto border-collapse border-2 border-slate-300">
                  <thead className="bg-gray-800 text-white">
                    <tr>
                      <th
                        scope="col"
                        className="px-5 py-3 border-b-2 border-gray-200 text-center text-xs font-semibold uppercase tracking-wider text-white"
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 border-b-2 border-gray-200 text-center text-xs font-semibold uppercase tracking-wider text-white"
                      >
                        Titre
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 border-b-2 border-gray-200 text-center text-xs font-semibold uppercase tracking-wider text-white"
                      >
                        Contenu
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 border-b-2 border-gray-200 text-center text-xs font-semibold uppercase tracking-wider text-white"
                      >
                        Tag
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {updatesData.length > 0 ? (
                      updatesData.map((update) => (
                        <tr
                          key={update.id}
                          className="hover:bg-gray-100 dark:hover:bg-gray-400 hover:dark:text-white dark:text-black text-sm"
                        >
                          <td className="px-5 py-3 text-center">
                            {format(new Date(update.date_update), "dd/MM/yy")}
                          </td>
                          <td className="px-5 py-3">{update.title_update}</td>
                          <td
                            className="px-5 py-3"
                            dangerouslySetInnerHTML={{
                              __html: update.content_update,
                            }}
                          ></td>

                          <td className="px-5 py-3">
                            <span
                              className={`px-2 py-1 rounded text-white text-xs ${
                                update.tag_update === "Bug"
                                  ? "bg-yellow-500"
                                  : update.tag_update === "New"
                                  ? "bg-blue-500"
                                  : update.tag_update === "Update"
                                  ? "bg-green-500"
                                  : "bg-gray-400"
                              }`}
                            >
                              {update.tag_update}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center py-4 px-6 text-gray-800"
                        >
                          Aucune requête disponible.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default RequestsAdmin;
